// icons.ts
export const VehicleIcons = {
  carRepair: 'mdi:car-wrench',
  accountBox: 'mdi:account-box',
  locationOn: 'mdi:map-marker',
  settings: 'mdi:cog',
  noteAlt: 'mdi:note-text',
  accountCircle: 'mdi:account-circle',
  directionsCar: 'mdi:car',
  build: 'mdi:hammer',
  work: 'mdi:briefcase',
  description: 'mdi:file-document',
  home: 'mdi:home',
  public: 'mdi:earth'
};

export const ContactIcons = {
  link: 'mdi:link',
  assignment: 'mdi:assignment',
  locationCity: 'mdi:city',
  person: 'mdi:account',
  contactPage: 'mdi:account-box',
  call: 'mdi:phone',
  email: 'mdi:email',
  place: 'mdi:map-marker',
  house: 'mdi:home',
  flag: 'mdi:flag',
  checkCircle: 'mdi:check-circle',
  group: 'mdi:account-group',
  note: 'mdi:note-text',
  pinDrop: 'mdi:pin',
  public: 'mdi:earth'
};

// iconify-icons.ts
export const SitesIcons = {
  locationOn: 'mdi:map-marker',
  phone: 'mdi:phone',
  email: 'mdi:email',
  home: 'mdi:home',
  public: 'mdi:earth',
  place: 'mdi:map-marker-outline',
  noteAlt: 'mdi:note-text',
  description: 'mdi:file-document',
  work: 'mdi:briefcase'
};

// iconify-icons.ts
export const DriverIcons = {
  person: 'mdi:account',
  phone: 'mdi:phone',
  email: 'mdi:email',
  key: 'mdi:key',
  lock: 'mdi:lock',
  group: 'mdi:account-group',
  localShipping: 'mdi:truck',
  business: 'mdi:briefcase-outline',
  directionsCar: 'mdi:car',
  home: 'mdi:home',
  checkCircle: 'mdi:check-circle',
  calendarToday: 'mdi:calendar',
  personAdd: 'mdi:account-plus',
  description: 'mdi:file-document-outline'
};
